<script setup lang="ts">
import { Swiper, SwiperSlide } from 'swiper/vue'
import { Autoplay, Pagination, Navigation } from 'swiper/modules'


const swiperModules = [Autoplay, Pagination, Navigation]

defineProps<{
  items: any[];
  slidesPerView?: number;
  spaceBetween?: number;
  autoplay?: boolean;
  pagination?: boolean;
  navigation?: boolean;
}>()
</script>

<template>
  <swiper
    :modules="swiperModules"
    :slides-per-view="slidesPerView || 1"
    :space-between="spaceBetween || 0"
    :loop="autoplay"
    :autoplay="autoplay ? { delay: 5000, disableOnInteraction: false } : false"
    :speed="1000"
    :pagination="pagination ? { clickable: true } : false"
    :navigation="navigation"
    :breakpoints="(slidesPerView && slidesPerView > 1) ? {
      320: { slidesPerView: 2, spaceBetween: 20 },
      768: { slidesPerView: Math.max(2, slidesPerView - 1), spaceBetween: 30 },
      1024: { slidesPerView: slidesPerView, spaceBetween: spaceBetween || 40 }
    } : undefined"
    class="vox-carousel"
  >
    <swiper-slide v-for="(item, index) in items" :key="index">
      <slot :item="item" :index="index" />
    </swiper-slide>
  </swiper>
</template>

<style scoped>
.vox-carousel {
  width: 100%;
  height: 100%;
  overflow: hidden;
  border-radius: inherit;
}

:deep(.swiper-pagination-bullet-active) {
  background: var(--voxbet-neon-green);
}

:deep(.swiper-button-next),
:deep(.swiper-button-prev) {
  color: var(--voxbet-neon-green);
}
</style>
